import { useState } from "react";

/**
 * Hook personnalisé pour gérer le partage de recettes
 */
const useShareRecipe = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const shareRecipe = async (recipeId, shareOptions) => {
    setIsLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem("token");
      console.log("🔑 Token trouvé:", token ? "Oui" : "Non");

      if (!token) {
        throw new Error("Authentification requise - Veuillez vous reconnecter");
      }

      const response = await fetch(
        `http://localhost:3000/api/recipes/${recipeId}/share`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(shareOptions),
        }
      );

      const data = await response.json();
      console.log("📡 Réponse du serveur:", response.status, data);

      if (!response.ok) {
        console.error("❌ Erreur serveur:", data);
        throw new Error(
          data.message || `Erreur ${response.status}: ${response.statusText}`
        );
      }

      console.log("✅ Partage réussi:", data);
      return data;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const getSharedStatus = async (recipeId) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        return null;
      }

      const response = await fetch(
        `http://localhost:3000/api/recipes/${recipeId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        const recipe = await response.json();
        return {
          isShared: recipe.is_shared,
          shareMessage: recipe.share_message,
          allowComments: recipe.allow_comments,
          showAuthorInfo: recipe.show_author_info,
        };
      }
      return null;
    } catch (err) {
      console.error(
        "Erreur lors de la récupération du statut de partage:",
        err
      );
      return null;
    }
  };

  return {
    shareRecipe,
    getSharedStatus,
    isLoading,
    error,
    clearError: () => setError(null),
  };
};

export default useShareRecipe;
